<template>
  <div v-bind:class="{ 'horizontal-spec': horizontalSpec === true }" style="flex:1;">
    <div style="display:flex;">
      <div class="column column-one" style="flex:1;">
        <div>
          <vehicle-meta :quote="quote" :driverGradesById="driverGradesById"/>

          <div v-if="quote.derivative.primaryTechnicalItems" class="single-view-image">
            <vehicle-image :derivative="quote.derivative" :showMain="true" :showThumbs="true" :enableGallery="true"/>
            <estimated-electric-costs v-if="fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription) && !hideEstimatedElectricCosts"
              class="mb-4"
              :quote="quote"
              :averagePencePerMile="averagePencePerMile">
            </estimated-electric-costs>
            <mpg-slider v-else-if="showMpgSliderIfApplicable" class="mb-4" :quote="quote" :default-mpg="quote.derivedMPG" />
          </div>
        </div>

        <div v-if="!horizontalSpec && quote.derivative.primaryTechnicalItems">
          <comparison-additional
            :derivative="quote.derivative"
            :p11dValue="quote.quote.details.pricing.p11DValue"
            :quote="quote"
          />
        </div>
      </div>

      <div v-if="quote.derivative.primaryTechnicalItems" class="column column-two single-view-image" style="flex:1;">
        <vehicle-image :derivative="quote.derivative" :styleOverrides="{ 'max-height': '300px', 'text-align': 'right' }" :showMain="true" :showThumbs="true" :enableGallery="true"/>
        <estimated-electric-costs v-if="fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription) && !hideEstimatedElectricCosts"
          class="mb-4" :quote="quote"
          :averagePencePerMile="averagePencePerMile" />
        <mpg-slider v-else-if="showMpgSliderIfApplicable" class="mb-4" :quote="quote" :default-mpg="quote.derivedMPG" />
      </div>
    </div>

    <div v-if="horizontalSpec && quote.derivative.primaryTechnicalItems" class="horizontal">
      <comparison-additional
        :derivative="quote.derivative"
        :p11dValue="quote.quote.details.pricing.p11DValue"
        :quote="quote"
      />
    </div>
  </div>
</template>

<script>
import EstimatedElectricCosts from "@/components/car-comparison/estimated-electric-costs";
import MpgSlider from "@/components/car-comparison/mpg-slider";
import AdditionalData from '@/components/car-comparison/comparison-additional';
import VehicleImage from "@/components/vehicle-details/vehicle-image";
import VehicleMeta from "@/components/car-comparison/vehicle-meta.vue";
import ComparisonAdditional from "@/components/car-comparison/comparison-additional";
import { fuelTypeElectricOrPluginHybrid } from "@/helpers/fuel-type";

export default {
  name: "single-vehicle",
  components: { MpgSlider, EstimatedElectricCosts, VehicleImage, AdditionalData, VehicleMeta, ComparisonAdditional },
  methods: { fuelTypeElectricOrPluginHybrid },
  props: [
    'quote',
    'sideBySide',
    'averagePencePerMile',
    'showMpgSliderIfApplicable',
    'horizontalSpec',
    'hideEstimatedElectricCosts',
    'driverGradesById',
  ],
}
</script>

<style scoped>

</style>
